import React from 'react';
import { CheckCircle } from 'lucide-react';

const ForWhomSection = ({ t }) => {
  return (
    <section className="py-20 bg-[#F5F3F0]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2
              className="text-4xl sm:text-5xl font-light text-[#2C2C2C] mb-6"
              style={{ fontFamily: 'Cormorant Garamond, serif' }}
            >
              {t.forWhomSection.title}
            </h2>
            <div className="w-24 h-1 bg-[#C4B5A0] mx-auto mb-6"></div>
            <p className="text-lg text-[#8B7D6B] font-medium">
              {t.forWhomSection.subtitle}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {t.forWhomSection.points.map((point, index) => (
              <div
                key={index}
                className="flex items-start gap-4 p-6 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300"
              >
                <CheckCircle className="w-6 h-6 text-[#C4B5A0] flex-shrink-0 mt-1" />
                <p className="text-[#2C2C2C] leading-relaxed">{point}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ForWhomSection;
